import card_icon from 'assets/green_card.svg';
import info_icon from 'assets/green_info.svg';
import shield_icon from 'assets/green_shield.svg';

export const BUY_TOKENS_FEATURE = 'Image Generation';

export const FEATURES = [
  BUY_TOKENS_FEATURE,
  'All Images Unblurred',
  'Secret Scenarios: 5x More Content',
  'No Message Limits',
  'Faster Responses',
  'Advanced AI',
  'Customization'
];

export const PAYMENTS_INFO = [
  {
    label: 'EroPlay.ai won’t access your payment data. Transactions are processed securely.',
    icon: shield_icon
  },
  {
    label: `No adult transaction on your statement: Payment to "SIA ChatMist" as "Premium Access features"`,
    icon: info_icon
  },
  {
    label: (
      <span>
        Google Pay, Apple Pay, VISA, MasterCard
        <br />
        No hidden fees. Cancel anytime
      </span>
    ),
    icon: card_icon
  }
];

export const TRIAL_BUTTON_DATA = {
  title: 'Go to Featured Scenarios',
  subText: 'FREE messages available there!',
};
